import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/visitors";

export const Route = createFileRoute("/admin/_residents/visitors")({
  component: Page,
});
